import { cn } from "@/lib/utils";

interface KnowledgeCardSkeletonProps {
  className?: string;
}

/** 知识库卡片骨架屏 */
export const KnowledgeCardSkeleton: React.FC<KnowledgeCardSkeletonProps> = ({ className }) => {
  return (
    <div className={cn("w-full relative", className)}>
      <div className="w-full h-full rounded-[12px] group px-1 py-2 cursor-default select-none">
        <div className="relative w-full rounded-[12px] mb-[10px]">
          <div className="overflow-hidden flex-shrink-0">
            {/* 骨架屏图标区域 */}
            <div className="w-full h-36 bg-gray-200 animate-pulse rounded-[12px]"></div>
          </div>
        </div>
        <div className="">
          {/* 骨架屏标题区域 - 两行文本 */}
          <div className="w-full flex flex-col gap-2">
            <div className="h-4 bg-gray-200 animate-pulse rounded w-3/4 mx-auto"></div>
          </div>
          {/* 骨架屏时间区域 */}
          <div className="w-full mt-1 text-center">
            <div className="h-3 bg-gray-200 animate-pulse rounded w-2/3 mx-auto"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

/** 批量知识库卡片骨架屏组件 */
export const KnowledgeSkeletonList: React.FC<{ count?: number }> = ({ 
  count = 8, 
}) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <KnowledgeCardSkeleton key={index} />
      ))}
    </>
  );
};